<template>
  <div v-if="showItem" class="item-box">
    <p>
      <slot name="item-star"></slot>
      <template v-if="title === 'Send shipping' || title === 'Return shipping'">
        <span v-show="desc" class="item-title">{{ desc }}</span>
        <br />
        <i-tag v-show="days" color="#37C3BA">
          {{ days + (days == '1' ? ' Business Day' : ' Business Days') }}
        </i-tag>
      </template>
      <template v-else>
        <span class="item-title">{{ title }}</span>
        <i-tag v-show="days" color="#37C3BA">
          {{ days + (days == '1' ? ' Business Day' : ' Business Days') }}
        </i-tag>
        <br />
        <span v-show="desc" class="item-desc">{{ desc }}</span>
      </template>
    </p>
    <p style="text-align: end">
      <span v-show="price && price !== '0'" class="item-price">${{ price }}</span>
      <br />
      <span v-show="originPrice && originPrice !== '0'" class="tips">
        Retail price <em class="info-price">${{ originPrice }}</em>
      </span>
      <span v-show="price === '0'" class="item-price">TBD</span>
      <img v-show="img" :src="img" />
      <slot name="item-end"></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'DropdownItem',
  props: ['title', 'desc', 'price', 'img', 'days', 'originPrice'],
  computed: {
    showItem() {
      if (this.title === 'Pick up' && this.price && this.price === '0') {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/fonts/font.less';
@import '../../assets/css/main.less';
.item-box {
  width: 966px;
  height: 75px;
  border-bottom: 1px solid #eeeff0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .item-title {
    .font-light;
    font-size: 18px;
    font-weight: 300;
    color: @app-black-color;
    line-height: 22px;
    margin-right: 9px;
  }
  .item-desc {
    .font-light;
    font-size: 18px;
    font-weight: 300;
    color: #afb5c6;
    line-height: 22px;
  }
  .tips {
    .font-light;
    font-size: 17px;
    font-weight: 300;
    color: @app-body-color;
    text-shadow: 0 2px 10px rgba(191, 191, 193, 0.3);
  }
  .info-price {
    .tips;
    text-decoration: line-through;
  }
  .item-price {
    .font-medium;
    font-size: 18px;
    font-weight: 500;
    color: @app-black-color;
    line-height: 22px;
  }
  img {
    width: 150px;
    height: 50px;
    margin-bottom: 12px;
  }
}
</style>
